export default "__VITE_ASSET__BJMyM$3y__"